// need to use fuse directly here
// eslint-disable-next-line no-restricted-imports
import Fuse from "fuse.js";

export type FuseOptions<T> = Fuse.IFuseOptions<T>;

/** Creates a Fuse instance outside React; components should use `useFuse` instead. */
export const createFuse = <T>(collection: readonly T[], options: FuseOptions<T>): Fuse<T> =>
  new Fuse(collection, options);

export const findLongestIndices = (
  indices: readonly (readonly number[])[],
): readonly [number, number] => {
  return indices.reduce<[number, number]>(
    (bestIdx, nextIdx) => {
      const bestLength = bestIdx[1] - bestIdx[0];
      const nextLength = nextIdx[1] - nextIdx[0];

      return nextLength > bestLength ? [nextIdx[0], nextIdx[1]] : bestIdx;
    },
    [0, 0],
  );
};

export const findLongestIndicesLength = (indices: readonly (readonly number[])[]): number => {
  const longestIndices = findLongestIndices(indices);
  return longestIndices[1] - longestIndices[0];
};

export const findLongestMatchLength = (
  matches: ReadonlyArray<Fuse.FuseResultMatch | Fuse.FuseSortFunctionMatch>,
): number => {
  return matches.reduce<number>((bestMatchLength, nextMatch) => {
    const nextLength = findLongestIndicesLength(nextMatch.indices);
    return Math.max(nextLength, bestMatchLength);
  }, 0);
};

export const sortByBestMatch = (resA: Fuse.FuseSortFunctionArg, resB: Fuse.FuseSortFunctionArg) => {
  return (
    findLongestMatchLength(resB.matches ?? []) - findLongestMatchLength(resA.matches ?? []) ||
    (resB.matches?.length || 0) - (resA.matches?.length || 0)
  );
};
